import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { ErrorNote, Loading, Page } from "./common";

export function Parity() {
  const { data, isLoading, error } = useQuery({ queryKey: ["parity"], queryFn: api.parity });
  if (isLoading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const rows = data ?? [];
  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Client admin portal</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>What a client admin can do in their own MLS console versus what TRIBUS staff can do here.</div>
      </div>
      <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", padding: "10px 18px", fontSize: 10.5, fontWeight: 600, letterSpacing: ".5px", textTransform: "uppercase", color: "#a8aca6", borderBottom: "1px solid #f4f3ee" }}>
          <span>Area</span><span>Client admin</span><span>Staff</span>
        </div>
        {rows.map((r) => (
          <div key={r.area} style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", padding: "11px 18px", fontSize: 12.5, borderTop: "1px solid #f4f3ee", alignItems: "start", gap: 10 }}>
            <span style={{ fontWeight: 600 }}>{r.area}</span>
            <span style={{ color: "#4a504a" }}>{r.clientAdmin}</span>
            <span style={{ color: "#4a504a" }}>{r.staff}</span>
          </div>
        ))}
      </div>
    </Page>
  );
}
